import { createAction } from 'redux-actions';

export const changeSearchOption = createAction('CHANGE_SEARCH_OPTION');
export const changeSearchValue = createAction('CHANGE_SEARCH_VALUE');
export const changeDefaultLanguage = createAction('CHANGE_DEFAULT_LANGUAGE');
export const changeDefaultLanguageCustom = createAction('CHANGE_DEFAULT_LANGUAGE_CUSTOM');
export const setSelectedState = createAction('SET_SELECTED_STATE');
export const setSelectedTag = createAction('SET_SELECTED_TAG');
